<template>
  <div class="md-layout">
    <md-button @click="updateMe()" class="md-layout-item md-size-20 md-raised addBtn">Update my data</md-button>
    <md-button
      @click="addAdventure()"
      class="md-layout-item md-size-20 md-raised addBtn"
    >Ajouter Aventure</md-button>
    <md-button
      @click="addArticle()"
      class="md-layout-item md-size-20 md-raised addBtn"
    >Ajouter Article</md-button>
    <md-button
      @click="addToolbox()"
      class="md-layout-item md-size-20 md-raised addBtn"
    >Ajout catégorie toolbox</md-button>
    <div class="md-layout-item md-size-100 bigTitle">Update color</div>
    <div class="md-layout-item md-size-40 bigTitle">
      <Chrome v-model="colors"></Chrome>
      <md-button @click="onUpdateBg()" class="md-layout-item md-size-20 md-raised addBtn">UPDATE BG</md-button>
      <Chrome v-model="colorsText"></Chrome>
      <md-button
        @click="onUpdateText()"
        class="md-layout-item md-size-20 md-raised addBtn"
      >UPDATE TEXT</md-button>
    </div>
    <div
      class="md-layout-item md-size-50 bigTitle md-layout md-alignment-center-center"
      :style="{ backgroundColor : colors.hex || colors, color: colorsText.hex || colorsText}"
    >
      <div class="md-layout-item md-size-100" style="text-align: center">Ceci est un test</div>
    </div>
    <div class="md-layout-item md-size-100 bigTitle">Update article</div>
    <div class="md-layout-item md-size-100 md-layout">
      <div
        @click="goToArticleEditor(a)"
        :key="index"
        v-for="(a,index) in getDraftArticles"
        class="md-layout-item md-size-20 articleBtn"
      >{{a.title}}</div>
    </div>
    <div class="md-layout-item md-size-100 bigTitle">Update aventure</div>
    <div class="md-layout-item md-size-100 md-layout">
      <div
        @click="goToAdventureEditor(a)"
        :key="index"
        v-for="(a,index) in getAllAdventuresList"
        class="md-layout-item md-size-20 articleBtn"
      >{{a.title}}</div>
    </div>
    <div class="md-layout-item md-size-100 bigTitle">Update toolbox</div>
    <div class="md-layout-item md-size-100 md-layout">
      <div
        @click="goToToolBoxEditor(a)"
        :key="index"
        v-for="(a,index) in getAllToolsBoxList"
        class="md-layout-item md-size-20 articleBtn"
      >{{a.title}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Chrome } from "vue-color";
// @ is an alias to /src

export default {
  name: "me",
  components: {
    Chrome
  },
  mounted() {
    console.log(this.getBgColor, this.getTextColor);
    this.colors = this.getBgColor;
    this.colorsText = this.getTextColor;
  },
  data() {
    return {
      colors: { hex: "#000000" },
      colorsText: { hex: "#000000" }
    };
  },
  methods: {
    ...mapActions(["updateBgColor", "updateTextColor"]),
    onUpdateText() {
      this.updateTextColor(this.colorsText.hex);
    },
    onUpdateBg() {
      console.log(this.colors.hex);
      this.updateBgColor(this.colors.hex);
    },
    updateMe() {
      this.$router.push("dashboard/me");
    },
    addAdventure() {
      this.$router.push("dashboard/adventure");
    },
    addArticle() {
      this.$router.push("dashboard/article");
    },
    goToArticleEditor(article) {
      this.$router.push({ name: "article2", params: { truc: article } });
    },
    goToAdventureEditor(adventure) {
      this.$router.push({ name: "adventureEditor", params: { adventure } });
    },
    goToToolBoxEditor(tb) {
      this.$router.push({ name: "toolboxeditor", params: { truc: tb } });
    },
    addToolbox() {
      this.$router.push("dashboard/toolbox");
    }
  },
  computed: {
    ...mapGetters([
      "getDraftArticles",
      "getAllAdventuresList",
      "getAllToolsBoxList",
      "getBgColor",
      "getTextColor"
    ])
  }
};
</script>

<style >
.addBtn {
  background-color: white;
  color: black;
  height: 50px;
}
.addBtn:hover {
  cursor: pointer;
}

.articleBtn {
  background-color: white;
  margin: 10px;
  padding: 10px;
  cursor: pointer;
}
</style>
